package com.tovtalk.data.mapper

import com.tovtalk.data.network.BandwidthEstimator
import com.tovtalk.data.network.VideoQuality
import com.tovtalk.data.remote.dto.MusicDto
import com.tovtalk.data.remote.dto.PostDtoV2
import com.tovtalk.domain.entity.*
import com.tovtalk.utils.logger.Logger

private const val TAG = "TT_VIDEO"

/**
 * Post Mapper - V2 DTO to Domain Entity
 */
fun PostDtoV2.toPost(bandwidth: BandwidthEstimator): Post {
    val quality = bandwidth.recommendedQuality()
    val selectedUrl = media.sources[quality.key]
        ?: media.sources["mid"]
        ?: media.sources.values.firstOrNull()
        ?: ""

    val actualKey = when {
        media.sources.containsKey(quality.key) -> quality.key
        media.sources.containsKey("mid") -> "mid (fallback)"
        media.sources.isNotEmpty() -> "${media.sources.keys.first()} (fallback)"
        else -> "none"
    }
    val sizeKb = media.sizes?.get(quality.key)?.let { it / 1024 } ?: -1
    Logger.d("post_map | post_id=$id | quality=${quality.key} | actual=$actualKey | size_kb=$sizeKb | available=${media.sources.keys}", TAG)

    return Post(
        id = id,
        ref = ref,
        type = PostType.fromString(type),
        caption = caption,
        hashtags = hashtags ?: emptyList(),
        videoUrl = selectedUrl,
        videoQuality = quality,
        allSources = media.sources,
        videoSizes = media.sizes,
        thumbnail = media.thumbnail,
        duration = media.duration?.toInt(),
        stats = PostStats(
            views = stats.views.toLong(),
            likes = stats.likes.toLong(),
            comments = stats.comments.toLong(),
            saves = stats.saves.toLong(),
            shares = stats.shares.toLong()
        ),
        author = author?.let {
            PostAuthor(
                id = it.id,
                username = it.username,
                fullname = it.fullname,
                profilePhoto = it.profilePhoto,
                hasActiveStory = it.hasActiveStory
            )
        } ?: PostAuthor(id = 0, username = "deleted", fullname = null, profilePhoto = null),
        viewerState = ViewerState(
            isLiked = viewer.isLiked,
            isSaved = viewer.isSaved,
            isFollowing = viewer.isFollowing
        ),
        createdAt = parseInstant(createdAt),
        originalVideoTime = originalVideoTime?.let { parseInstant(it) },
        expiresAt = expiresAt?.let { parseInstant(it) },
        isExpired = isExpired,
        isPermanent = isPermanent,
        isPinned = isPinned,
        uploadedViaAdmin = uploadedViaAdmin
    )
}

private fun mapMusicToEntity(dto: MusicDto): Music {
    return Music(
        id = dto.id,
        title = dto.title,
        artist = dto.artist,
        audioUrl = dto.audioUrl,
        thumbnail = dto.thumbnail,
        duration = dto.duration,
        categoryId = dto.categoryId
    )
}


